import * as PricebooksActions from "./pricebooksActions";

export default PricebooksActions;
